import { Injectable } from '@angular/core';
import { DocumentChangedInfo, DocumentInfo } from '@formbird/types';
import { FormbirdInjectorService } from '../injector/formbird-injector.service';

@Injectable({
  providedIn: 'root'
})
export class ChangedDocumentService {

  ajsService: any;

  constructor(private injector: FormbirdInjectorService) {
    this.ajsService = injector.get('ChangedDocumentService');
  }

  /**
   * Listen value changes on a specified document field
   * @param fieldName the field name of document
   * @param documentId the document id
   * @param controlName the registered control that holds the field value in this component. It is used to check on the source of change
   * to avoid applying changes itself and also applying the value from the components that share the field name.
   * @param options provides more information for the watch.
   */
  watch(fieldName, documentId, controlName?, options?) {
    return this.ajsService.watch(fieldName, documentId, controlName, options);
  }

  /**
   * Provide the change information for the specified document field that the component binds to
   * @param component the component binds to the field
   * @param newValue the changed/new value
   * @param controlName the registered control manages the field value
   * @param options the options
   */
  valueChanged(component, value: any, controlName?: string, options?: any) {
    this.ajsService.valueChanged(component, value, controlName, options);
  }

  dispatchChanged(documentChangedInfo: DocumentChangedInfo) {
    this.ajsService.dispatchChanged(documentChangedInfo);
  }

  executeOnFieldChangeWithNoChanges(component) {
      this.ajsService.executeOnFieldChangeWithNoChanges(component);
  }

  watchDocument(documentId) {
      return this.ajsService.watchDocument(documentId);
  }

  watchStoreChanges() {
      return this.ajsService.watchStoreChanges();
  }

  dispatchAction(action) {
      this.ajsService.dispatchAction(action);
  }

  watchComponentTemplate(templateId) {
      return this.ajsService.watchComponentTemplate(templateId);
  }

  watchComponentDef(fieldName, templateId) {
      return this.ajsService.watchComponentDef(fieldName, templateId);
  }

  notifyIntializedField(component, shouldDispatchEmptyFieldValue?) {
      return this.ajsService.notifyIntializedField(component, shouldDispatchEmptyFieldValue);
  }

  notifyDocumentChanged(documentChangedInfo: DocumentChangedInfo) {
      return this.ajsService.notifyDocumentChanged(documentChangedInfo);
  }

  notifyComponentDefinitionUpdated(templateId, fieldName, key, componentDefinition) {
      return this.ajsService.notifyComponentDefinitionUpdated(templateId, fieldName, key, componentDefinition);
  }

  setOrgDocument(document) {
      return this.ajsService.setOrgDocument(document);
  }

  setDocumentInfo(unsavedDocumentListId, docInfo: DocumentInfo) {
      return this.ajsService.setDocumentInfo(unsavedDocumentListId, docInfo);
  }

  setDocument(document) {
      return this.ajsService.setDocument(document);
  }

  setComponentFlagTemplate(templateId, fieldName, flagName, flagValue) {
      return this.ajsService.setComponentFlagTemplate(templateId, fieldName, flagName, flagValue);
  }

  isLoadedDocument(documentId, unsavedDocumentListId) {
      return this.ajsService.isLoadedDocument(documentId, unsavedDocumentListId);
  }
}
